.groups .group .bar {
  min-height: 46px;
  line-height: 46px;
  border-radius: 4px;
  padding-left: 20px;
  margin-top: 4px;
}
.groups .group .title {
  background-color: rgb(22.5641025641%, 18.4615384615%, 4.1025641026%);
  color: rgb(94.8717948718%, 89.7435897436%, 71.7948717949%);
}
.groups .group .add {
  display: block;
  background-color: var(--plus-color-back);
}
.groups .group .add .name {
  margin-right: 8px;
}
.groups .group .add .icon {
  color: var(--plus-color-icon);
}
.groups .group .add.selected {
  background-color: var(--plus-color-selected);
}
.groups .group .edit {
  display: inline-block;
  width: 32px;
  height: 32px;
  line-height: 32px;
  margin-top: 7px;
  text-align: center;
  margin-right: 8px;
  background-color: rgb(94.8717948718%, 89.7435897436%, 71.7948717949%);
  color: rgb(22.5641025641%, 18.4615384615%, 4.1025641026%);
  border-radius: 4px;
  float: right;
  cursor: pointer;
}
.groups .group .delete {
  background-color: #f8d7da;
  color: #842029;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkdyb3Vwc1ZpZXcuc2FzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFhSTtFQUNFLFlBTFU7RUFNVixhQU5VO0VBT1Y7RUFDQTtFQUNBOztBQUNGO0VBQ0Usa0JBZk87RUFnQlAsT0FkVTs7QUFlWjtFQUNFO0VBQ0E7O0FBQ0E7RUFDRTs7QUFDRjtFQUNFOztBQUNGO0VBQ0U7O0FBQ0o7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBLGtCQWhDVTtFQWlDVixPQW5DTztFQW9DUDtFQUNBO0VBQ0E7O0FBQ0Y7RUFDRTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiQHVzZSBcInNhc3M6Y29sb3JcIlxuXG5AdXNlICcuLi8uLi91aS9zaG9wLnNhc3MnXG5cbiRncm91cC1jb2xvcjogI2I5MlxuJGdyb3VwLWRhcms6IGNvbG9yLmFkanVzdCgkZ3JvdXAtY29sb3IsICRsaWdodG5lc3M6IC0zMCUsICRzcGFjZTogaHNsKVxuJGdyb3VwLWxpZ2h0OiBjb2xvci5hZGp1c3QoJGdyb3VwLWNvbG9yLCAkbGlnaHRuZXNzOiAzMCUsICRzcGFjZTogaHNsKVxuJGdyb3VwLWxpZ2h0ZXI6IGNvbG9yLmFkanVzdCgkZ3JvdXAtY29sb3IsICRsaWdodG5lc3M6IDQwJSwgJHNwYWNlOiBoc2wpXG5cbiRoZWFkZXItaGVpZ2h0OiA0NnB4XG5cbi5ncm91cHNcbiAgLmdyb3VwXG4gICAgLmJhclxuICAgICAgbWluLWhlaWdodDogJGhlYWRlci1oZWlnaHRcbiAgICAgIGxpbmUtaGVpZ2h0OiAkaGVhZGVyLWhlaWdodFxuICAgICAgYm9yZGVyLXJhZGl1czogNHB4XG4gICAgICBwYWRkaW5nLWxlZnQ6IDIwcHhcbiAgICAgIG1hcmdpbi10b3A6IDRweFxuICAgIC50aXRsZVxuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJGdyb3VwLWRhcmtcbiAgICAgIGNvbG9yOiAkZ3JvdXAtbGlnaHRlclxuICAgIC5hZGRcbiAgICAgIGRpc3BsYXk6IGJsb2NrXG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1wbHVzLWNvbG9yLWJhY2spXG4gICAgICAubmFtZVxuICAgICAgICBtYXJnaW4tcmlnaHQ6IDhweFxuICAgICAgLmljb25cbiAgICAgICAgY29sb3I6IHZhcigtLXBsdXMtY29sb3ItaWNvbilcbiAgICAgICYuc2VsZWN0ZWRcbiAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0tcGx1cy1jb2xvci1zZWxlY3RlZClcbiAgICAuZWRpdFxuICAgICAgZGlzcGxheTogaW5saW5lLWJsb2NrXG4gICAgICB3aWR0aDogMzJweFxuICAgICAgaGVpZ2h0OiAzMnB4XG4gICAgICBsaW5lLWhlaWdodDogMzJweFxuICAgICAgbWFyZ2luLXRvcDogN3B4XG4gICAgICB0ZXh0LWFsaWduOiBjZW50ZXJcbiAgICAgIG1hcmdpbi1yaWdodDogOHB4XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkZ3JvdXAtbGlnaHRlclxuICAgICAgY29sb3I6ICRncm91cC1kYXJrXG4gICAgICBib3JkZXItcmFkaXVzOiA0cHhcbiAgICAgIGZsb2F0OiByaWdodFxuICAgICAgY3Vyc29yOiBwb2ludGVyXG4gICAgLmRlbGV0ZVxuICAgICAgYmFja2dyb3VuZC1jb2xvcjogI2Y4ZDdkYVxuICAgICAgY29sb3I6ICM4NDIwMjlcbiJdfQ== */